export default "__VITE_ASSET__B611APfJ__"